import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const styles = {
    success: {
      border: 'border-emerald-500/50',
      text: 'text-emerald-400',
      glow: 'shadow-[0_0_20px_rgba(16,185,129,0.1)]',
    },
    error: {
      border: 'border-red-500/50',
      text: 'text-red-500',
      glow: 'shadow-[0_0_20px_rgba(239,68,68,0.1)]',
    },
    info: {
      border: 'border-blue-500/50',
      text: 'text-blue-400',
      glow: 'shadow-[0_0_20px_rgba(59,130,246,0.1)]',
    }
  };

  const currentStyle = styles[type] || styles.success;

  return (
    // Backdrop blur added here: bg-black/40 backdrop-blur-sm
    <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4 pointer-events-none bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-300">
      <div
        className={`
          bg-[#0a0a0a] border ${currentStyle.border} ${currentStyle.glow}
          w-auto min-w-[280px] max-w-sm
          px-8 py-4
          rounded-2xl 
          shadow-2xl
          transform animate-in zoom-in slide-in-from-bottom-2 duration-200
          pointer-events-auto
        `}
      >
        <p
          className={`
            text-center font-bold italic uppercase
            text-[11px] tracking-[0.15em]
            leading-relaxed
            ${currentStyle.text}
          `}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default Toast;